/*global GridFormAndImporterController, WebView*/
var ibantools = require("ibantools") ;

module.exports = function createJournalController(routes){
    var controller = new GridFormAndImporterController("account_journal",
        {
            grid: {
                directory: "views/journal",
                searchRecords: {type: ["cash", "bank"]},
                name: "journalGrid",
                route: routes.gridRoute,
                canImport: true,
                joinFetch: [
                    { otherTable: "account_account", name: "accountCredit", otherField: "id", thisField: "default_credit_account_id"},
                    { otherTable: "res_partner_bank", name: "bankAccount", otherField: "id", thisField: "bank_account_id", joins: [
                        { otherTable: "res_bank", name: "bank"},
                    ]}
                ]
            },
            importer: {
                route: routes.importerRoute,
            },
            form: {
                directory: "views/journal",
                name: "journalForm",
                route: routes.formRoute,
                defaultData: {
                    active: true
                },
                joinFetch: [
                    { otherTable: "account_account", name: "accountCredit", otherField: "id", thisField: "default_credit_account_id"},
                    { otherTable: "res_partner_bank", name: "bankAccount", otherField: "id", thisField: "bank_account_id", joins: [
                        { otherTable: "res_bank", name: "bank"},
                    ]}
                ],
                tableToCheckBeforeDelete: [
                    "account_move_line"
                ]
            },
        }
    );

    controller.formController.validations.push(function checkIBAN(params, callback){
        if(!params.data.bankAccount){ return callback();}
        if(!params.data.bankAccount.acc_number){ return callback();}
        if(!ibantools.isValidIBAN(params.data.bankAccount.acc_number)){
            return callback(null, {field: "res_partner_bank.acc_number", msg: WebView.tr("customer.incorrectIBAN")}) ;
        }
        callback() ;
    }.bind(controller.formController)) ;

    controller.formController.validations.push(function checkBIC(params, callback){
        if(!params.data.bankAccount){ return callback();}
        if(!params.data.bankAccount.bank){ return callback();}
        if(!params.data.bankAccount.bank.bic){ return callback();}
        if(!ibantools.isValidBIC(params.data.bankAccount.bank.bic)){
            return callback(null, {field: "res_bank.bic", msg: WebView.tr("customer.incorrectBIC")}) ;
        }
        callback() ;
    }.bind(controller.formController)) ;

    controller.formController.getRecordsToSave = function(viewData, dataBeforeModif, callback){
        this.api.db.multiread({
            res_company: {searchFirst: {}},
            account_account_type: {searchFirst: {type: "liquidity"}, orderBy: "id"},
        }, function(err, reads){
            if(err){ return callback(err) ;}

            this.view.updateData() ;
            var journal = this.data ;

            var records = [] ;

            if(this.data.accountCredit.code){
                records.push({
                    table: "account_account",
                    action: "insertOrUpdate",
                    conditions: {
                        code: this.data.accountCredit.code,
                        // internal_type: 'liquidity'
                    },
                    record: {
                        company_id: reads.res_company.id,
                        name: this.data.name,
                        code: this.data.accountCredit.code,
                        user_type_id: reads.account_account_type.id,
                        internal_type: 'liquidity'
                    }
                }) ;
                journal.default_credit_account_id = "${account_account.id}" ;
                journal.default_debit_account_id = "${account_account.id}" ;
            } else {
                journal.default_credit_account_id = null ;
            }

            var bank_id = null;
            if(journal.bankAccount && journal.bankAccount.bank && journal.bankAccount.bank.bic){
                records.push({
                    table: "res_bank",
                    action: "insertOrUpdate",
                    conditions: {
                        bic: journal.bankAccount.bank.bic,
                    },
                    record: {
                        bic: journal.bankAccount.bank.bic,
                        name: journal.bankAccount.bank.bic,
                    }
                }) ;
                bank_id = "${res_bank.id}" ;
            }

            var bank_account_id = null ;
            if(journal.bankAccount && journal.bankAccount.acc_number){
                if(journal.bankAccount.id){
                    bank_account_id = journal.bankAccount.id;
                    records.push({
                        table: "res_partner_bank",
                        action: "update",
                        record: {
                            id: journal.bankAccount.id,
                            bank_id: bank_id,
                            acc_number: journal.bankAccount.acc_number,
                        }
                    }) ;
                }else{
                    records.push({
                        table: "res_partner_bank",
                        action: "insert",
                        record: {
                            bank_id: bank_id,
                            acc_number: journal.bankAccount.acc_number,
                        }
                    }) ;
                    bank_account_id = "${res_partner_bank.id}";
                }
            }

            journal.bank_account_id = bank_account_id ;

            records.push({
                table: "account_journal",
                record: journal
            }) ;

            callback(null, records) ;
        }.bind(this)) ;
    } ;

    return controller ;
} ;
